import React, { useState } from 'react';
import axios from 'axios';
import kycImage from './kyc2.png';
import logo from './c_logo.png'; // Import the logo

const MobileInput = ({ email, setStep }) => {
  const [mobileInput, setMobileInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [mobileFocused, setMobileFocused] = useState(false);

  const handleSubmit = async () => {
    // Validate mobile number
    if (!mobileInput.trim()) {
      alert('Mobile number is required');
      return;
    } else if (!mobileInput.match(/^[6-9]\d{9}$/)) {
      alert('Please enter a valid 10-digit Indian mobile number starting with 6-9');
      return;
    }

    const payload = {
      mobile: mobileInput,
      email: email, // Include the email in the payload
      purpose: 'To perform KYC of the individual',
      redirect_url: 'https://decentro.tech/',
      callback_url: 'https://backend-22l3.onrender.com/api/kyc/callback',
    };

    setLoading(true);
    try {
      const response = await axios.post('https://backend-22l3.onrender.com/api/kyc/initiate', payload);
      console.log('KYC response:', response.data.data);
      console.log(response.data);
    
      if (response.status === 200 && response.data?.data.url) {
        window.location.href = response.data.data.url;
      } else {
        alert('No redirect URL received from KYC API');
      }
    
    } catch (err) {
      console.error('KYC request failed:', err);
    
      if (err.response) {
        console.log(`Status: ${err.response.status}`);
        console.log('Error message:', err.response.data?.error);
    
        if (err.response.status === 400) {
          alert(err.response.data?.error || 'Something went wrong');
        }
      } else {
        alert('Something went wrong while making the request');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.headerContainer}>
        <div style={styles.headerTitle}>Coin Street - Online KYC Portal</div>
        <img src={logo} alt="Company Logo" style={styles.logo} />
      </div>
      
      <div style={styles.contentContainer}>
        <div style={styles.formSection}>
          <h2 style={styles.verifyTitle}>Enter Your KYC Details</h2>
          
          <div style={styles.inputGroup}>
            <div style={styles.floatingLabelContainer}>
              <label 
                style={{
                  ...styles.floatingLabel,
                  ...((mobileFocused || mobileInput) && styles.floatingLabelFocused),
                  ...(mobileFocused && { color: '#0033a0' })
                }}
              >
                Mobile Number
              </label>
              <input
                type="tel"
                value={mobileInput}
                onChange={(e) => setMobileInput(e.target.value)}
                onFocus={() => setMobileFocused(true)}
                onBlur={() => setMobileFocused(false)}
                style={{
                  ...styles.textInput,
                  ...(mobileFocused && styles.inputFocused)
                }}
                required
              />
            </div>
          </div>
          
          <div style={styles.buttonGroup}>
            <button 
              onClick={handleSubmit} 
              disabled={loading} 
              style={styles.verifyButton}
            >
              {loading ? 'Processing...' : 'Start KYC'}
            </button>
          </div>

          {/* Important Notes Section */}
          <div style={styles.notesContainer}>
            <h3 style={styles.notesTitle}>Important Notes:</h3>
            <ul style={styles.notesList}>
              <li style={styles.noteItem}>KYC is mandatory as per SEBI regulations</li>
              <li style={styles.noteItem}>We use digi-locker API to validate your KYC details</li>
              <li style={styles.noteItem}>You will be redirected to digi-locker website</li>
              <li style={styles.noteItem}>Kindly enter your details there and validate it via OTP</li>
            </ul>
          </div>
        </div>
        
        <div style={styles.illustrationSection}>
          <img src={kycImage} alt="KYC Illustration" style={styles.kycIllustration} />
        </div>
      </div>
      
      <div style={styles.footer}>
        <div style={styles.footerText}>SEBI RIA: INA000001382</div>
        <div style={styles.footerText}>www.coinstreet.in</div>
        <div style={styles.footerText}>support@coinstreet.in</div>
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    fontFamily: 'Poppins, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    overflow: 'hidden',
    justifyContent: 'space-between'
  },
  headerContainer: {
    flex: '0 0 54px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 18px',
    backgroundColor: '#fff',
    boxShadow: '0 1.8px 4.5px rgba(0, 0, 0, 0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    width: '100%',
    boxSizing: 'border-box'
  },
  headerTitle: {
    fontSize: 'calc(12.6px + 0.72vw)',
    fontWeight: 'bold',
    color: '#0033a0',
    '@media (max-width: 768px)': {
      fontSize: '14.4px'
    }
  },
  logo: {
    height: '72px',
    objectFit: 'contain',
    '@media (max-width: 768px)': {
      height: '54px'
    }
  },
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '18px',
    width: '100%',
    boxSizing: 'border-box',
    overflow: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flexDirection: 'column-reverse',
      padding: '9px'
    }
  },
  formSection: {
    flex: '0 0 40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '13.5px',
    padding: '0 18px',
    maxWidth: '450px',
    width: '100%',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 992px)': {
      flex: '1 0 auto',
      maxWidth: '100%',
      margin: '0',
      padding: '18px 9px'
    }
  },
  verifyTitle: {
    fontSize: '21.6px',
    fontWeight: 'bold',
    color: '#0033a0',
    marginBottom: '9px',
    '@media (max-width: 768px)': {
      fontSize: '18px',
      marginBottom: '4.5px'
    }
  },
  inputGroup: {
    width: '100%',
    marginBottom: '18px',
    '@media (max-width: 768px)': {
      marginBottom: '13.5px'
    }
  },
  floatingLabelContainer: {
    position: 'relative',
    width: '100%'
  },
  floatingLabel: {
    position: 'absolute',
    left: 10.8,
    top: 10.8,
    color: '#999',
    fontSize: '12.6px',
    pointerEvents: 'none',
    transition: 'all 0.2s ease',
    backgroundColor: 'transparent',
    padding: '0 3.6px'
  },
  floatingLabelFocused: {
    top: -7.2,
    left: 7.2,
    fontSize: '10.8px',
    backgroundColor: '#fff',
    padding: '0 3.6px'
  },
  textInput: {
    width: '100%',
    padding: '10.8px',
    borderRadius: '3.6px',
    border: '0.9px solid #ccc',
    fontSize: '12.6px',
    boxSizing: 'border-box',
    marginBottom: '13.5px',
    outline: 'none',
    transition: 'all 0.3s ease'
  },
  inputFocused: {
    border: '1.8px solid #0033a0',
    boxShadow: '0 0 0 1.8px rgba(0, 51, 160, 0.2)'
  },
  buttonGroup: {
    display: 'flex',
    gap: '13.5px',
    marginTop: '9px'
  },
  verifyButton: {
    padding: '10.8px',
    backgroundColor: '#0033a0',
    color: 'white',
    border: 'none',
    borderRadius: '3.6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    flex: 1,
    transition: 'background-color 0.3s',
    ':hover': {
      backgroundColor: '#002080'
    }
  },
  notesContainer: {
    marginTop: '18px',
    padding: '13.5px',
    borderRadius: '3.6px',
    borderLeft: '3.6px solid #0033a0',
    '@media (max-width: 768px)': {
      marginTop: '9px',
      padding: '9px',
      fontSize: '11.7px'
    }
  },
  notesTitle: {
    fontSize: '14.4px',
    fontWeight: 'bold',
    color: '#0033a0',
    marginBottom: '9px',
    '@media (max-width: 768px)': {
      fontSize: '12.6px',
      marginBottom: '4.5px'
    }
  },
  notesList: {
    margin: 0,
    paddingLeft: '18px',
    '@media (max-width: 768px)': {
      paddingLeft: '13.5px'
    }
  },
  noteItem: {
    fontSize: '12.6px',
    color: '#555',
    marginBottom: '7.2px',
    lineHeight: '1.26',
    '@media (max-width: 768px)': {
      fontSize: '10.8px',
      marginBottom: '4.5px'
    }
  },
  illustrationSection: {
    flex: '0 0 55%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 0', // Increased padding to ensure image doesn't touch edges
    '@media (max-width: 992px)': {
      flex: '0 0 auto',
      width: '100%',
      maxHeight: '21vh', // Further reduced by 15% from 25vh
      margin: '0 0 9px 0',
      transform: 'none'
    }
  },
  kycIllustration: {
    maxWidth: '76.5%', // Reduced by 15% from 90%
    maxHeight: '63.75%', // Reduced by 15% from 75%
    objectFit: 'contain',
    '@media (max-width: 992px)': {
      maxHeight: '68%' // Reduced by 15% from 80%
    }
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '13.5px 9px',
    backgroundColor: '#fff',
    flexWrap: 'wrap',
    flexShrink: 0,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '4.5px',
      padding: '9px'
    }
  },
  footerText: {
    flex: '1 0 auto',
    textAlign: 'center',
    fontSize: '19.8px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 400,
    color: '#012C9C',
    margin: '0 18px',
    '@media (max-width: 768px)': {
      fontSize: '10.8px',
      margin: '1.8px 0'
    }
  }
};

export default MobileInput;